import { graphql } from 'gatsby'
import ComponentsManager from '../utils/components-manager'
import Layout from '../layout/layout'
import SEO from "./seo"
import React from 'react'
import { getSrc } from "gatsby-plugin-image"



const DarReport = (props) => {
    let node = props.data.nodeDarReports
    const img = getSrc(node.relationships.field_image?.localFile?.childImageSharp?.gatsbyImageData)
    return (
        <Layout invertHeader={true}>
            <SEO title={node.title} description={node.field_summary || 'Explore our reports for data and insights on the college admissions process that you can only get from Common App.'} image={img} article={true}/>
            <article>
                <ComponentsManager node={node}
                                    breadcrumbCategory={props.pageContext.breadcrumbCategory}
                                    components={node.relationships.field_components} />
                {node.field_link_to_full_report?.uri?
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-8 offset-lg-2 offset-xl-2 dar-report-read-more'>
                                <a href={node.field_link_to_full_report.uri} style={{ color: '#0b6dbd' }}>Read the report</a>
                            </div> 
                        </div>
                    </div>
                    : null}
            </article>
        </Layout>
    )

}

export default DarReport

export const DarReportQuery = graphql`
query DarReportQuery($drupalNodeId: Int!) {
    nodeDarReports(drupal_internal__nid: {eq: $drupalNodeId}) {
        title,
        field_report_author_source,
        field_summary,
        field_link_to_full_report {
            uri
        },
        relationships {
            field_image {
                localFile {
                    childImageSharp {
                        gatsbyImageData(width: 300, layout: FIXED)
                    }
                }
            }
            field_components {
                __typename
                
                ...ParagraphsFixedContent
                ...ParagraphsSingleCardGradientBorderB
                ...ParagraphsSingleCardGradientBorder
                ...ParagraphsBluePhotoBanner
                ...ParagraphNewsletterSignup
                ...ParagraphTextCtaImage
                ...ParagraphsTwoCardsGradientBorder
                ...ParagraphsQuoteStatement
                
                ...ParagraphsVideoAndText
                ...ParagraphsBlogPostsCards
                ...ParagraphsEventListing
                
            }
        }
    }
}`
